import callAPI from '../callAPI';

import {
  SET_CAMPAIGNS,
  COMPLETE_CAMPAIGN,
  FAIL_TO_SET_NEW_CAMPAIGNS,
  RATE_CAMPAIGN
  // FAIL_TO_COMPLETE_CAMPAIGN,
  // FAIL_TO_SEND_ENGAGEMENT_ANSWERS,
} from './constants';
import {logAmplitudeFeedRetrievalEvent} from "../../amplitude";


// Redux
// ========================
/*
  Gets all campaigns from main feed and add to Redux
*/
function isCampaignValid(campaign) {
  if (!campaign) {
    return false
  }
  if (!campaign.engagements) {
    return true
  }
  for (let i = 0; i < campaign.engagements.length; i++) {
    let e = campaign.engagements[i];

    if (e.kind === 'choose' && (!e.firstImageURL || !e.options || e.options.length < 1))
      return false;
    if (e.kind === 'this_or_that' && (!e.firstImageURL || !e.secondImageURL))
      return false;
    if (e.kind === 'ratable' && (!e.videoURL))
      return false;
    if (e.kind === 'qa' && (!e.firstImageURL || !e.secondImageURL || !e.options || e.options.length < 1 || e.correctAnswerId.length < 1 || e.correctAnswerText.length < 1))
      return false;
  }

    return true;
}

export function sortCompare(c1, c2) {
  if (c1.campaignComplete && !c2.campaignComplete) {
    return 1;
  }
  if (!c1.campaignComplete && c2.campaignComplete) {
    return -1
  }
  return 0; //c2.totalValue - c1.totalValue
}

export function getCampaigns() {
  return (dispatch, getState) => {
    return callAPI({
      method: 'GET',
      path: '/app/v1/mainFeed?page=0&size=100'
    })(dispatch, getState)
    // Remove campaigns with no engagements - backend bug
    .then(res => {
      if (res && res.error)
        return Promise.reject(res);

      else if (res && res.data) {
        let campaigns = res.data
        .filter(c => isCampaignValid(c))                          // filter out campaigns with broken engagements
        // .filter(c => (c.engagements && c.engagements.length > 0)) // filter out empty campaigns
        .filter(c => (c.feedItemType !== 'milestone'))            // filter out milestones
        .sort(sortCompare)               // sort campaigns by value
        .map(c => ({                                              // sort engagements by ordinal
          ...c,
          tags: c.tags.filter(t => (!t.verify)), // filter omsdk tags
          engagements: c.engagements ? c.engagements
            .map(e => ({
              ...e,
              tags: e.tags.filter(t => (!t.verify)) // filter omsdk tags
            }))
            .sort((a,b) => a.ordinal - b.ordinal) : []
        }));
        logAmplitudeFeedRetrievalEvent(campaigns)
        return campaigns
      }

      else return [];
    })
    .then(newCampaigns => {
      dispatch({
        type: SET_CAMPAIGNS,
        payload: newCampaigns
      });
    })
    .catch(err => {
      dispatch({type: FAIL_TO_SET_NEW_CAMPAIGNS});
      console.error('Failed to get new campaigns from main feed.');
      console.error(err);
    });
  }
}

/*
  Remove campaign from Redux
*/
export function finishCampaign(campaignId) {
  return (dispatch, getState) => {
    if (!campaignId)
      throw new Error('Must provide campaignId to remove campaign from state.');

    dispatch({
      type: COMPLETE_CAMPAIGN,
      payload: campaignId
    });
  }
}

export function rateCampaign(campaignId, userRating) {
  return (dispatch, getState) => {
    if (!campaignId)
      throw new Error('Must provide campaignId to remove campaign from state.');

    dispatch({
      type: RATE_CAMPAIGN,
      payload: { campaignId: campaignId, userRating: userRating}
    });
  }
}

/*
  Send Campaign Completion Answers

  @params
    - completionAnswer <Object>
        userFeedback <String>  Required
        userRating   <Integer> Required
    - campaignId <String>
*/
export function postCampaignCompletionAnswer(completionAnswer={}) {
  return (dispatch, getState) => {
    const userId = getState().auth.userId;
    const { campaignId, userRating } = completionAnswer;

    // Validate Campaign Completion Answers
    if (campaignId === undefined || campaignId === null)
      throw new Error('Campaign completion must include a campaign id.');
    if (userRating === undefined)
      throw new Error('Campaign completion answer must include a rating.');
    if (userId === undefined || userId === null)
      throw new Error('Campaign completion answer requires a user id.');

    var data = {
      campaignId:   campaignId,
      userRating:   userRating
    };

    return callAPI({
      method: 'POST',
      path: '/app/v1/rateCampaign',
      body: data
    })(dispatch, getState)
    .catch(err => {
      console.error('Failed to save campaign completion answer to API.');
      console.error(err);
    });
  }
}

export function trackCtaClick(campaignId) {
  return (dispatch, getState) => {
    return callAPI({
      method: 'POST',
      path: '/app/v1/user/campaign/' + campaignId + '/ctaclick',
      body: ""
    })(dispatch, getState)
    .catch(err => {
      console.error('Failed to save campaign completion answer to API.');
      console.error(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/redux/campaigns/actions.js